import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { useGeneralSheetHook } from "../../hooks/sheet.hook";

const Footer = ({ showmap = true }) => {
  const sheet_data = useGeneralSheetHook();

  const publicUrl = process.env.PUBLIC_URL ? process.env.PUBLIC_URL + "/" : "/";

  return (
    <footer className="site-footer">
      <div className="site-footer__top">
        <div className="container">
          <div className="row">
            <div
              className="col-xl-6 col-lg-6 col-md-6 wow fadeInUp"
              data-wow-delay="100ms"
            >
              <div className="footer-widget__column footer-widget__about">
                <div className="footer-widget__about-logo">
                  <Link to={publicUrl}>
                    <img
                      src={`${publicUrl}assets/images/resources/footer-logo.png`}
                      alt="Footer Logo"
                      style={{ maxWidth: "290px" }}
                    />
                  </Link>
                </div>
                <ul className="list-unstyled footer-widget__list">
                  <li>
                    <div className="icon">
                      <span className="icon-place"></span>
                    </div>
                    <div className="text">
                      <p>{sheet_data.address}</p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span className="icon-call"></span>
                    </div>
                    <div className="text">
                      <p>
                        <a
                          href={`tel:${sheet_data.phone_number_1.replace(
                            "`",
                            ""
                          )}`}
                        >
                          +{sheet_data.phone_number_1.replace("`", "")}
                        </a>
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span className="icon-call"></span>
                    </div>
                    <div className="text">
                      <p>
                        <a
                          href={`tel:${sheet_data.phone_number_2.replace(
                            "`",
                            ""
                          )}`}
                        >
                          +{sheet_data.phone_number_2.replace("`", "")}
                        </a>
                      </p>
                    </div>
                  </li>
                  <li className="d-non">
                    <div className="icon">
                      <span className="icon-envelope"></span>
                    </div>
                    <div className="text">
                      <p>
                        <a href={`mailto:${sheet_data.email}`}>
                          {sheet_data.email}
                        </a>
                      </p>
                    </div>
                  </li>
                </ul>
                <div className="footer-widget__social">
                  {!!sheet_data.facebook && (
                    <a href={sheet_data.facebook} target="_blank">
                      <i className="fab fa-facebook"></i>
                    </a>
                  )}

                  {!!sheet_data.twitter && (
                    <a href={sheet_data.twitter} target="_blank">
                      <i className="fab fa-twitter"></i>
                    </a>
                  )}

                  {!!sheet_data.tiktok && (
                    <a href={sheet_data.tiktok} target="_blank">
                      <i className="fab fa-tiktok"></i>
                    </a>
                  )}

                  {!!sheet_data.youtube && (
                    <a href={sheet_data.youtube} target="_blank">
                      <i className="fab fa-youtube"></i>
                    </a>
                  )}

                  {sheet_data.instagram && (
                    <a href={sheet_data.instagram} target="_blank">
                      <i className="fab fa-instagram"></i>
                    </a>
                  )}
                </div>
              </div>
            </div>
            <div
              className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp"
              data-wow-delay="200ms"
            >
              <div className="footer-widget__column footer-widget__service clearfix">
                <h3 className="footer-widget__title">Service</h3>
                <ul className="footer-widget__service-list list-unstyled clearfix">
                  <li>
                    <Link to={`${publicUrl}what-we-do#entertainment`}>
                      Entertainment and Culture
                    </Link>
                  </li>
                  <li>
                    <Link to={`${publicUrl}what-we-do#branding`}>
                      Branding and Advertising
                    </Link>
                  </li>
                  <li>
                    <Link to={`${publicUrl}what-we-do#automobile`}>
                      Automobile Purchase/ Sales and Services
                    </Link>
                  </li>
                  <li>
                    <Link to={`${publicUrl}what-we-do#tourism`}>
                      Tourist Services
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp"
              data-wow-delay="300ms"
            >
              <div className="footer-widget__column footer-widget__links clearfix">
                <h3 className="footer-widget__title">Quick Link</h3>
                <ul className="footer-widget__links-list list-unstyled clearfix">
                  <li>
                    <Link to={`${publicUrl}donate-now`}>Donate</Link>
                  </li>
                  <li>
                    <Link to={`${publicUrl}projects#concept-transformation`}>
                      Heroes of Tomorrow project
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            {showmap && (
              <div
                className="col-xl-12 col-lg-12 col-md-12 wow fadeInUp mt-5"
                data-wow-delay="300ms"
              >
                <div className="footer-widget__column footer-widget__map clearfix">
                  <div className="footer-widget__map-box">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3963.6197277585993!2d3.3431929749933174!3d6.569585693423737!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b92071ad747bf%3A0x22e2a0c0503404a0!2sMagnet%20Shopping%20Plaza!5e0!3m2!1sen!2sng!4v1742277112375!5m2!1sen!2sng"
                      width="100%"
                      height="600"
                      style={{ border: "0px" }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="site-footer__bottom">
        <div className="container">
          <div className="site-footer__bottom-inner">
            <p className="site-footer__bottom-text">
              © {new Date().getFullYear()} Copyright by{" "}
              <a href="#">Concept Multi-Service Nig</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  showmap: PropTypes.bool,
};

Footer.defaultProps = {
  showmap: true,
};

export default Footer;
